module.exports = __webpack_public_path__ + "img/img-process3@2x.6711d951.jpg";